var map = {
	"./de/video-btn.png": "zgTW",
	"./en/video-btn.png": "kTIo",
	"./es/video-btn.png": "/6s7",
	"./fr/video-btn.png": "n7xr",
	"./ja/video-btn.png": "riPx",
	"./ko/video-btn.png": "by2z",
	"./pt/video-btn.png": "8/Xn",
	"./ru/video-btn.png": "4kCP",
	"./tc/video-btn.png": "AEx5",
	"./th/video-btn.png": "0XG9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZNtm";